import React from 'react';
import { LucideIcon as LucideIconType } from 'lucide-react';

interface MetricCardProps {
  title: string;
  value: string | number;
  percentage: number;
  link: string;
  icon: React.ElementType;
  color: {
    text: string;
    bg: string;
  };
}

const MetricCard: React.FC<MetricCardProps> = ({
  title,
  value,
  percentage,
  link,
  icon: Icon,
  color,
}) => {
  return (
    <div
      className={`relative bg-gradient-to-br from-[#0F1629] to-[#1A1F2E] rounded-xl p-5 overflow-hidden group transition-all duration-300 hover:shadow-lg hover:shadow-${color.bg}/10 cursor-pointer`}
      onClick={() => window.open(link, '_parent')}
    >
      {/* Background glow effect */}
      <div className={`absolute inset-0 bg-gradient-to-br from-transparent via-transparent to-${color.bg}/5 opacity-50`} />
      
      <div className="relative">
        {/* Header */}
        <div className="flex items-center justify-between mb-6">
          <div className="flex items-center space-x-2">
            <h3 className="text-sm font-medium text-gray-400">{title}</h3>
          </div>
          <div className={`p-2 rounded-lg bg-${color.bg}/10 transition-colors duration-300 group-hover:bg-${color.bg}/15`}>
            <Icon className={`h-4 w-4 ${color.text}`} />
          </div>
        </div>

        {/* Value and Progress */}
        <div className="space-y-4">
          <div className={`text-4xl font-bold ${color.text} transition-colors duration-300`}>
            {value}
          </div>
          <div className="space-y-2">
            <div className="flex items-center justify-between">
              <span className="text-sm text-gray-500">{percentage}%</span>
            </div>
            <div className="h-1 rounded-full bg-gray-800/50 overflow-hidden">
              <div
                className={`h-full rounded-full ${color.bg} transition-all duration-500 ease-out`}
                style={{ 
                  width: `${percentage}%`,
                  boxShadow: `0 0 10px ${color.bg}` 
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MetricCard;